import donutChart from 'britecharts/dist/umd/donut.min';
import {select} from 'd3-selection';
import {validateConfiguration, validateContainer} from '../helpers/validation';
import {applyConfiguration} from '../helpers/configuration';

import { donut as donutLoadingState } from 'britecharts/dist/umd/loading.min';

const donut = {};

donut.create = (el, data, configuration = {}) => {
    const container = select(el);
    const chart = donutChart();

    validateContainer(container);
    validateConfiguration(chart, configuration);

    // Calls the chart with the container and dataset
    container.datum(data).call(applyConfiguration(chart, configuration));

    return chart;
};

donut.update = (el, data, configuration = {}, chart) => {
    const container = select(el);

    validateContainer(container);
    validateConfiguration(chart, configuration);
    applyConfiguration(chart, configuration);

    // Calls the chart with the container and dataset
    if (data) {
        container.datum(data).call(chart);
    } else {
        container.call(chart);
    }

    return chart;
};

donut.destroy = () => {};

donut.loading = () => donutLoadingState;

export default donut;
